// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1GotB","label":"CategoryService_label__lk6YM","location":"CategoryService_location__1_sxb"};